import { createStyles } from 'antd-style';

import { ThemeColors } from '../../theme';

export const useButtonsStyles = createStyles(({ token }) => ({
  dotButton: {
    cursor: 'pointer',
    fontSize: token.fontSizeSM,
    width: '1em',
    height: '1em',
    borderRadius: '100%',
    backgroundColor: ThemeColors.COLOR_GREY7_2,
    '&.active': {
      backgroundColor: ThemeColors.COLOR_GREY2,
    },
  },
}));
